import React from "react";
import "./GetMusicOnYoutube.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnYoutube = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select YouTube Music distribution",
    "Release approved by stores",
    "Go live worldwide",
    "Track streams & revenue"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on YouTube Music | Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to YouTube Music with FT Tunes. Reach millions of listeners and monetize your music worldwide on YouTube."
        />

        <meta
          name="keywords"
          content="YouTube Music distribution, upload music to YouTube Music, distribute music to YouTube, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="youtube-page">

        {/* HERO */}
        <section className="youtube-hero">
          <Container>

            <img
              src="/Images/youtube-logo.png"
              alt="YouTube Music Distribution"
              className="youtube-logo"
            />

            <h1>Get Your Music on YouTube Music</h1>

            <p>
              Share your music with millions of fans worldwide through
              YouTube Music. Monetize streams, reach new audiences,
              and grow your music career globally.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-youtube"></div>
        </section>


        {/* SHOWCASE */}
        <section className="youtube-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Billions of Listeners</h2>

                <p>
                  Distribute your music to YouTube Music and YouTube's
                  global ecosystem. Earn revenue from streams,
                  Content ID monetization, and fan engagement.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-you-tube.png"
                  alt="YouTube Platform"
                  className="youtube-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="youtube-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="youtube-benefits">
          <Container>

            <h2 className="section-title">
              Why Artists Choose YouTube Music
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Massive Audience</h5>
                  <p>Reach billions of global viewers.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Monetization</h5>
                  <p>Earn from streams & Content ID.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Video + Audio</h5>
                  <p>Distribute music videos & tracks.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Keep Ownership</h5>
                  <p>You retain 100% rights.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="youtube-cta">
          <Container>

            <h2>Release Your Music on YouTube Music Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnYoutube;